export default theme => ({
    deleteBtn: {
        position: 'absolute',
        left: 5
    }
  });
  